// @flow
import React from 'react';
import { Trans } from 'react-i18next';

import Button from 'app/common/ui/Button';
import IconBtnGo from 'app/components/_Icons/IconBtnGo';
import Indicator from 'app/components/Subs/Indicator';
import NotEnoughLink from 'app/components/Tariff/NotEnoughLink';
import Confirmation from 'app/components/Tariff/Confirmation';

import styles from './AppFooter.scss';


type Props = {
  subId?: number | string,
  showIndicator?: boolean,
  appLink: string,
  notPaid: boolean,
  freeServices: boolean,
  handlePay: (e: SyntheticEvent<HTMLElement>) => void,
};

const AppFooter = ({ showIndicator = false, appLink, subId, notPaid, freeServices, handlePay }: Props) =>
  <div className={styles.root}>
    <div>
      {!freeServices && subId && !notPaid
        && <Indicator subId={subId} showCircle={showIndicator} showSmsPrepayd />}

      {/* Не достаточно средств */}
      {!freeServices && notPaid
        && <Confirmation
          name="mobile"
          onSubmit={handlePay}
          className={styles.confirmation}
          comment={
            <Trans i18nKey="subs:pay_confirm">Вы уверены?</Trans>
          }
        >
          {handle =>
            <div className={styles.danger}>
              <NotEnoughLink handlePay={handle} subId={subId} />
            </div>
          }
        </Confirmation>
      }
    </div>
    <Button href={appLink}>
      <Trans i18nKey="subs:open_bt">
        {'Открыть'}
      </Trans>
      <IconBtnGo />
    </Button>
  </div>;

export default AppFooter;
